import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import galleryTemplate from "templates/modules/product/product_image_gallery.jinja";
import Baustein from "web/react/components/baustein/baustein";
import Conditional from "web/react/components/conditional/conditional";
import ProductGallery from "web/react/components/product-gallery/product-gallery";
import { DesignerPropType } from "web/types/designer";
import { ProductPropType } from "web/types/product";
import { ProductCardPropType } from "web/types/product-card";

import "web/script/components/image-gallery";


function PDPGallery({ features, product, designer, relatedProducts }) {
    let showReactGallery = features.web_zoom_gallery_v2;
    return (
        <>
            <Conditional check={showReactGallery}>
                <div className="hidden-desktop hidden-tablet-only">
                    <ProductGallery
                        relatedProducts={relatedProducts}
                        showRelatedProducts={features.uj_gallery_related_products}
                        dotsInsideGallery={features.uj_dots_inside_gallery}
                        images={product.images}
                    />
                </div>
            </Conditional>
            <Baustein
                template={galleryTemplate}
                className={classnames({
                    "hidden-mobile": showReactGallery,
                })}
                args={{
                    modifier: "vertical-thumbnails",
                    product_image_gallery: {
                        product_id: product.product_id,
                        buy_option: null, // Always null
                        images: product.images,
                        designer: designer.name,
                        designer_link: designer.url,
                        images_count: product.images.length,
                        retailer_name: "", // Never used
                        view_similar_enabled: false, // Always false
                    },
                }}
            />
        </>
    );
}

PDPGallery.propTypes = {
    product: ProductPropType.isRequired,
    designer: DesignerPropType.isRequired,
    features: PropTypes.objectOf(PropTypes.bool).isRequired,
    relatedProducts: PropTypes.arrayOf(ProductCardPropType),
};
export default PDPGallery;
